import React, { JSX } from 'react'
import { Card, CardActions, CardContent, Grid, Box } from '@mui/material'
import MenuComponent, { MenuItems } from './MenuComponent'
import MediaCarousel from './MediaCarousel'
import TooltipComponent from './TooltipComponent'
import { useTranslation } from 'react-i18next'

interface Props {
  class?: 'primary' | 'secondary' | any
  imgClassName?: any
  imgWidth?: string
  content?: string | JSX.Element
  menuItem?: MenuItems[]
  actions?: JSX.Element
  images?: string[]
  onClick?: () => void
  maxHeight?: number
}

const CardComponent: React.FC<Props> = (props:Props) => {
  const { t } = useTranslation()
  return (
    <>
      <Card className={props.class} style={{ height: '100%' }}>
        <Grid container style={{ height: '100%' }}>
          {props.images && props.images.length > 0 &&
            <>
              <Grid item xs={4} className={props.imgClassName}>
                <CardContent style={{ padding: 0 }}>
                  <MediaCarousel items={props.images} height={225} maxWidth={props.imgWidth ? props.imgWidth : 225} navButtonsAlwaysVisible />
                </CardContent>
              </Grid>
            </>}
          <Grid container item xs={(props.images && props.images.length > 0) ? 8 : 12} style={{ display: 'grid', alignContent: 'space-between' }}>
            <Grid item xs={12}>
              <CardContent style={{ maxHeight: props.maxHeight ? props.maxHeight : '' }}>
                <Box>{props.content}</Box>
              </CardContent>
            </Grid>
            {props.actions && (
              <Grid item xs={12}>
                <CardActions>
                  <Grid container>
                    <Grid item xs={6}>
                      {props.actions && props.actions}
                    </Grid>
                    <Grid item xs={6} style={{ justifyContent: 'end', display: 'grid', alignItems: 'center' }}>
                      {props.menuItem &&
                          <TooltipComponent
                            placement='top' child={
                              <MenuComponent menuItem={props.menuItem} />
                            } title={`${t('common:options')}`}
                          />}
                    </Grid>
                  </Grid>
                </CardActions>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

export default CardComponent
